import React from 'react'
import { useState } from 'react';
import PhoneInput from 'react-phone-number-input'

import 'react-phone-number-input/style.css'
// import { useLocation } from 'react-router-dom';
const NumberInput = ({ Name, Value, HandleChange, disabledInput, width, countrySelectComponent, extraFun }) => {
    // const { pathname } = useLocation();
    // const splitLocation = pathname.split("/");
    const [countryMaxLength, setCountryMaxLength] = useState(15);
    const formatPhoneNumber = (value) => {
        if (!value) return '';
        const phoneNumber = value.replace(/[^\d]/g, '');
        const countryCode = phoneNumber.slice(0, 3);
        const number = phoneNumber.slice(3);
        return `+${countryCode} ${number}`;
    };
    const handleCountryChange = (selectedCountry) => {
        const countryName = selectedCountry;
        if (countryName === 'IN') {
            setCountryMaxLength((pre) => 15);
        } else {
            setCountryMaxLength((pre) => 20);
        }
    };
    return (
        <>
            <PhoneInput
                disabled={disabledInput}
                className={`${width && "w-100"} phone_Input`}
                countrySelectComponent={countrySelectComponent}
                defaultCountry={'IN'}
                countryCallingCodeEditable={false}
                international
                withCountryCallingCode
                value={Value && `${Value.includes("+") ? "" : "+"}${Value}`}
                onChange={(e) => {
                    HandleChange.setFieldValue(Name, e)
                    if (extraFun) {
                        if (e?.length > 7) {
                            extraFun(e)
                        }
                    }
                }}
                format={formatPhoneNumber}
                maxLength={countryMaxLength}
                onCountryChange={(country) => handleCountryChange(country)}
                placeholder="Enter phone number"

            />
        </>
    )
}

export default NumberInput
